export const FELLOU_GITHUB_URL = "https://github.com/FellouAI";
export const EKO_GITHUB_URL = "https://github.com/FellouAI/eko";
export const FELLOU_WEBSITE_URL = "https://fellou.ai";
export const AGENT_API_URL = "https://api.fellou.ai";
export const AGENT_API_URL_DEV = "https://api.fellou.ai";
export const LOGING_CALLBACK_URL = "loging-callback?scene=";

export const appDomain = "https://fellou.us.authing.co";
export const appId = "675660785f0163c8c5418ffe";
